import { useState, useEffect } from "react";
import { Stack, Typography } from "@mui/joy";
import LinearProgress from "@mui/joy/LinearProgress";
import Box from "@mui/system/Box";
import facts from "@/data/common/facts.json";
import { getRandomIndex } from "@/utils/arrays";

interface Props {
  loaderSize?: "sm" | "md" | "lg";
}

const QuoteLoader = ({ loaderSize }: Props) => {
  const [quoteIndex, setQuoteIndex] = useState(getRandomIndex(facts.length));

  useEffect(() => {
    const quoteInterval = setInterval(() => {
      setQuoteIndex(getRandomIndex(facts.length));
    }, 7000);

    return () => {
      clearInterval(quoteInterval);
    };
  }, []);

  return (
    <Stack
      direction={"column"}
      sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Box sx={{ marginTop: 2, textAlign: "center" }}>
        <LinearProgress size={loaderSize} />
        <Typography
          component={"p"}
          sx={{
            color: "neutral.500",
            m: 2,
          }}
        >
          {facts[quoteIndex].fact}
        </Typography>
        <Typography
          component={"p"}
          sx={{
            color: "neutral.500",
            m: 2,
            textAlign: "center",
            fontStyle: "italic",
          }}
        >
          - {facts[quoteIndex].name}
        </Typography>
      </Box>
    </Stack>
  );
};

export default QuoteLoader;
